import { Icon } from '@chakra-ui/react';

export const HeartIcon = (props: any) => (
  <Icon aria-label="heart icon" viewBox="4 4 16 16" {...props}>
    <path
      d="m16 5c2.4418278 0 4 1.49275853 4 4.59849108 0 2.36799362-2.5188893 5.31739152-7.5088475 9.03553852l-.4911525.3659704-.4911525-.3659704c-4.9899582-3.718147-7.5088475-6.6675449-7.5088475-9.03553852 0-3.10573255 1.5581722-4.59849108 4-4.59849108 1.18597905 0 2.5011568.68082579 4 2.00286381 1.4988432-1.32203802 2.8140209-2.00286381 4-2.00286381z"
      fill="currentColor"
    />
  </Icon>
);
